import AhoyTracker from 'shared/ahoy_tracker';

export default class SimilarFilm {
  constructor(options) {
    this.$container = options.$element;
    this.hasLoaded = false;
  }

  init() {
    if(!this.hasLoaded) {
      this.loadData();
      this.hasLoaded = true;
    }
  }

  loadData() {
    var filmId = this.$container.data("film-id");
    var url = "/larva_film/" + filmId;

    $.get(url).done(function(data) {
      this.$container.html(data);
      this.initJsAhoy();
    }.bind(this));
  }

   initJsAhoy() {
     let elements = this.$container.find('.js-ahoy');

     for(var i = 0; i < elements.length; i++) {
       let element = elements[i];
       if(element.dataset.ahoyloaded !== 'true'){

         var ahoy_tracker = new AhoyTracker(element);
         ahoy_tracker.init();

         element.dataset.ahoyloaded = 'true';
       }
     }
   }
}
